<template>
  <div>
    <div class="d-flex">
      <input
        type="hidden"
        v-model="model"
        class="form-control"
      />
    </div>
  </div>
</template>

<script>

import store from "@/store";

export default {
  props: {
    value: Array | Object,
    config: Object,
    type: String,
  },
  data() {
    return {
      model: null,
    };
  },
  created() {
  },
  mounted() {
    if (this.config.default) {
      this.model = this.config.default;
      this.$nextTick(() => this.$emit('input', this.model));
    } else {
      const fieldValue = this.getFieldValue();
      this.model = fieldValue;
      this.$nextTick(() => this.$emit('input', fieldValue));
    }
  },
  methods: {
    getFieldValue() {
      switch (this.config.name) {
        case 'user_id':
          return this.getUserId();
      }
    },
    getUserId() {
      const user = store.state.user.user;

      return user.id;
    }
  }
};
</script>

<style></style>
